export default "/app/global-wrapper-client/static/907ce2998952598ac01a92d645ec929d.woff2";